module.exports = __webpack_public_path__ + "static/img/16.70a4c07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/sp/16.png
// module id = plhe
// module chunks = 0